/** Features the listing preview shows before it is expanded - two columns of eight in a wide preview. */
export const COLLAPSED_FEATURE_COUNT = 16;
